// extracted by mini-css-extract-plugin
module.exports = {"errorcontainer":"error_errorcontainer__Lz2v8","errorimage":"error_errorimage__espmD"};